type SymbolOption<T extends string | number> = {
  value: T;
  symbol: string;
  label: string;
};

type Props<T extends string | number> = {
  options: readonly SymbolOption<T>[];
  disabled?: boolean;
  onValue: (value: T) => void;
  onErase: () => void;
};

export function SymbolPad<T extends string | number>({
  options,
  disabled = false,
  onValue,
  onErase,
}: Props<T>) {
  return (
    <div className="symbol-pad" aria-label="Symbol controls">
      {options.map((option) => (
        <button
          type="button"
          key={option.value}
          disabled={disabled}
          aria-label={`Place ${option.label}`}
          onClick={() => onValue(option.value)}
        >
          <span aria-hidden="true">{option.symbol}</span>
          <small>{option.label}</small>
        </button>
      ))}
      <button type="button" disabled={disabled} aria-label="Clear selected cell" onClick={onErase}>
        <span aria-hidden="true">⌫</span>
        <small>Erase</small>
      </button>
    </div>
  );
}
